const encoder = new TextEncoder()
export const validateUTF8StringLength = (value, maxLength) => encoder.encode(value).length <= maxLength
